module.exports = __webpack_public_path__ + "img/title_uk.7fc98133.svg";